// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3etqs","comment":"styles_comment__1YhY1"};